/* eslint-disable eqeqeq */
import { useState, useEffect, useCallback, useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { DataGrid } from "@mui/x-data-grid";
import Grid from "@mui/material/Grid";
import useMediaQuery from "@mui/material/useMediaQuery";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import Modal from "@mui/material/Modal"; 
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded"; 
import Box from "@mui/material/Box";
import GCLoadingListSearch from "./../../Component/Common/ReuseableComponent/GCLoadingListSearch";
import GCWebReport from "../../Component/Common/ReuseableComponent/GCWebReport";

import moment from "moment";
 
import {
  fAlertToast,
  GetGitterColumns,
  GetAccountPostingDetail,
  GetLinkDocument,
} from "../../Utility/Utilitys";
import { LoadingReceipt } from "../../Redux/roStore";
import { fExecuteAPI } from "../../Server/Apis";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
 
import GCHead from "./processComponent/GCHead";
import GCContent from "./processComponent/GCContent";
import WmsFooter from "./processComponent/WmsFooter";
import {
  Set_WmsLoadingReceipt_HeadObject_Set,
  Set_WmsLoadingReceipt_HeadObject_Init,
} from "./SliceWmsLoadingReceipt";
import "./LoadingReceipt.css";
import { Wms_LoadingReceipt_HeadObject_New_Set } from "./SliceWmsLoadingReceipt";
import {
  CmpButton,
  CmpButtonKIcon, 
} from "../../Component/Common/ToolBox/ToolBox";
import {
  fRightClick,
  fLeftClick,
  GridDataColumnsWmsSiDetail_Def,
  GridDataColumnsItemSearch_Def,
  //Headsearch start
  GridDataColumnsSearch_Def,
  sStatusArr,
  //headSearch end
  fKeyLoadingReceipt,
  fKeyLoadingReceiptContent,
  GetUnitArr,
  GetItemFullSearchArr,
  ItemSearchData,
  GetSearchItem,
  fItemCodeDependency,
  ErrorMsg,
  ErrorMsgDetail,
  fValidationHead_Client,
  fValidationDetail_Client,
  fLoad_Grid,
  fSaveHead,
  fDisplay,
  fBaseQtyCal,
  fApproveLoadingReceipt,
  GetAttributes,
  getTransItemStockUOM,
  sTrnTyp,
  Unit_Onchange_001,
} from "./LoadingReceiptAction";
// import { set } from 'date-fns/esm';
import { fcheck_null_undefine_replace_empty } from "../../Utility/Utilitys";
import { fCheck_Doc_Rights_001 } from "./../../Utility/Utilitys";
import { FShortCutKey } from "./../../Utility/Utilitys";
import GCAccountDetail from "./../../Component/Common/ReuseableComponent/GCAccountDetail";
import GCMenuBtn from "./../../Component/Common/ReuseableComponent/GCMenuBtn";
import GCLinkDocument from "./../../Component/Common/ReuseableComponent/GCLinkDocument";
import GCTitleSticky from "../../Component/Common/ReuseableComponent/GCTitleSticky";
import { DetailTblCard } from "./processComponent/DetailTblCard";
import GCNAV from "../../Component/Common/ReuseableComponent/GCNAV";

export default function WmsLoadingReceipt() {
  const dispatch = useDispatch();
  const [sShowMore, setShowMore] = useState(false); // nav bar arrow input value
  const [sRigntClick, setRigntClick] = useState(false); // nav bar arrow input value

  const vMediaQuery = useMediaQuery("(max-width:450px)");
  const vRdxuserInfo = useSelector((state) => state.login.value);
  const vRdxWmsHead = useSelector(
    (state) => state.SliceWmsLoadingReceipt.value.HeadObject
  );

  const vRdxDBLocation = useSelector((state) => state.SliceGRNLocation.value);
   const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);
  const [sNavDocValue, setNavDocValue] = useState(1); // nav bar arrow input value

  const [sRoundingVal, setRoundingVal] = useState(Number(vRdxDBKernObj.DIGIT_ROUNDING?.Val)||2);
  // eslint-disable-next-line no-unused-vars
  const [sEnterKeyObj, setEnterKeyObj] = useState({
    key: "Enter",
  });

  const [sObjRights, setObjRights] = useState({
    RNew: "Y",
    RSave: "Y",
    RDelete: "Y",
    RApprove: "Y",
    RPrint: "Y",
    RReverse: "Y",
    RClone: "Y",
  });
  const [sObjectRights, setObjectRights] = useState({
    DocTyp: "",
    Save: "Y",
    Edit: "Y",
    Del: "Y",
    View: "Y",
    Appr: "Y",
    Reverse: "Y",
    Cancel: "Y",
    Print: "Y",
    Clone: "Y",
    Lvl: "",
  });
  const [sUser_Doc_Arr, setUser_Doc_Arr] = useState([]);
  const [sTransItemStockObj, setTransItemStockObj] = useState({
    RPStock: 0,
    MSP: 0,
    CostPr: 0,
    LPRate: 0,
  });
  // eslint-disable-next-line no-unused-vars
  const [sGCSeachSalesGroupSearch, setGCSeachSalesGroupSearch] = useState([]); //GCSeachSalesGroupSearch Select

  //HEAD
  const [sDocLoading, setDocLoading] = useState([]);
  const [sLocationArr, setLocationArr] = useState([]);

  const [sErrorMsg, setErrorMsg] = useState(ErrorMsg);
  const [sErrorMsgDetail, setErrorMsgDetail] = useState(ErrorMsgDetail);

  //DETAIL
  const [sUnit, setUnit] = useState([]);
  const [sDetailGridData, setDetailGridData] = useState([]); //DetailGridData Select

  let vBufferObjInit = {
    B_Srno: 0, // int
    B_Itmcd: "",
    B_ItmName: "",
    B_Qty: (0).toFixed(sRoundingVal), //Decimal
    B_Unit: "",
    B_UnitName: "",
    B_PackQty: (0).toFixed(sRoundingVal), //Decimal
    B_BaseQty: (0).toFixed(sRoundingVal), //Decimal
    Packing: (0).toFixed(sRoundingVal),
  };

  const [sBufferObj, setBufferObj] = useState(vBufferObjInit);

  //HEAD FUNCTION
  const fGrnType = async (event) => {
    var vGrnType = sDocLoading?.find((obj, index) => {
      return obj.VocTyp === event.target.value;
    });

    dispatch(
      Set_WmsLoadingReceipt_HeadObject_Set({
        ...vRdxWmsHead,
        A_VocTyp: vGrnType?.VocTyp,
        A_VocTypName: vGrnType?.VocName,
      })
    );
  };

  const fGrnDate = (event) => {
    if (
      event?.$d == "Invalid Date" ||
      event?.$d == null ||
      event?.$d === undefined ||
      event?.$d === ""
    ) {
      dispatch(
        Set_WmsLoadingReceipt_HeadObject_Set({
          ...vRdxWmsHead,
          A_PostDt: "",
        })
      );
    } else {
      dispatch(
        Set_WmsLoadingReceipt_HeadObject_Set({
          ...vRdxWmsHead,
          A_PostDt: event?.$d,
        })
      );
    }

    // dispatch(
    //   Set_WmsLoadingReceipt_HeadObject_Set({
    //     ...vRdxWmsHead,
    //     A_PostDt: event?.$d,
    //   })
    // );
  };

  const fTruck = (event) => {
    dispatch(
      Set_WmsLoadingReceipt_HeadObject_Set({
        ...vRdxWmsHead,
        Truck: event.target.value,
      })
    );
  };
  const fDriver = (event) => {
    dispatch(
      Set_WmsLoadingReceipt_HeadObject_Set({
        ...vRdxWmsHead,
        Driver: event.target.value,
      })
    );
  };

  const fReceiptDate = (event) => {
    if (
      event?.$d == "Invalid Date" ||
      event?.$d == null ||
      event?.$d === undefined ||
      event?.$d === ""
    ) {
      dispatch(
        Set_WmsLoadingReceipt_HeadObject_Set({
          ...vRdxWmsHead,
          A_ReceiptDt: "",
        })
      );
    } else {
      dispatch(
        Set_WmsLoadingReceipt_HeadObject_Set({
          ...vRdxWmsHead,
          A_ReceiptDt: event?.$d,
        })
      );
    }
  };

  const fLocation = async (e) => {
    dispatch(
      Set_WmsLoadingReceipt_HeadObject_Set({
        ...vRdxWmsHead,
        A_Loc: e.target.value,
      })
    );
  };

  //FOOTER FUNCTION

  //DETAIL  FUNCTION

  const fContent_Focus = (e) => {
    if (e.target.value == 0) {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: "",
      }));
    }
  };

  const fContent_Blur = (e) => {
    if (e.target.value == "") {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: (0).toFixed(2),
      }));
    }
  };

  const fUnit = async (e) => {
    let vUnitvalue = sUnit.find((obj) => {
      return obj.Unit === e.target.value;
    });
    await Unit_Onchange_001(vUnitvalue, setBufferObj, sBufferObj);
  };

  const fItemName = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_ItmName: e.target.value,
    }));
  };

  const fQty = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_Qty: e.target.value,
    }));
    fBaseQtyCal(e.target.value, sBufferObj.B_PackQty, setBufferObj);
  };
  const fPacking = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      Packing: e.target.value,
    }));
  };
  const fQtyEnter = (e) => {
    if (e.key === "Enter" && vRdxWmsHead.A_DocStat == "ENTER") {
      document.getElementsByName("B_Qty")[0]?.blur();
      fSave();
    }
  };

  //Item Dropdowm
  const [sItemToggleDropdown, setItemToggleDropdown] = useState(false);
  const [sItemSearchDropdownObj, setItemSearchDropdownObj] = useState({
    Type: "Any",
    Data: "",
  });

  const fOnChangeItem = (e) => {
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fOnKeyUpItem = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      // SEARCHITEM001_GETROW
      GetSearchItem(
        sItemSearchDropdownObj.Data,
        sItemSearchDropdownObj.Type,
        vRdxWmsHead.A_Loc,
        setGridSelectRowData
      );
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const handleClick = useCallback(() => {
    if (sItemToggleDropdown) {
      setItemToggleDropdown(false);
      setGridSelectRowData([]);
      setItemSearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setItemToggleDropdown(true);
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
    }
  }, [sItemToggleDropdown]);

  const fItemToggleClick = (e) => {
    setGridSelectRowData([]);
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      Data: sBufferObj.B_ItmName,
    }));

    if (sBufferObj.B_ItmName != "") {
      GetSearchItem(
        sBufferObj.B_ItmName,
        "Any",
        vRdxWmsHead.A_Loc,
        setGridSelectRowData
      );
    }

    handleClick();
  };

  //ItemSearch
  const fItemSearchKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      let vItemSearchFull = await GetItemFullSearchArr(
        sBufferObj.B_ItmName,
        vRdxWmsHead.A_Loc
      );

      if (vItemSearchFull.length > 0) {
        fItemCodeDependency(vItemSearchFull, sBufferObj, setBufferObj, setUnit);
      } else {
        fItemToggleClick(e);
      }
    } else if (e.key === "Backspace") {
      setBufferObj((obj) => ({
        ...obj,
        B_Itmcd: "",
        B_ItmName: e.target.value,
        B_Barcode: "",
        B_Unit: "",
        B_UnitName: "",
        B_PackQty: "",
        Packing: "0",
      }));
      fBaseQtyCal(sBufferObj.B_Qty, 0, setBufferObj);
      setUnit([]);
    }
  };

  //MODAL HEAD

  //Modal ItemSearch
  const [sGridSelectRowData, setGridSelectRowData] = useState([]);

  //GCItemSearch
  const fGCToggleItemOnRowClick = async (e) => {
    let vItemSearchFull = await GetItemFullSearchArr(
      e.row.ItmCd,
      vRdxWmsHead.A_Loc
    );
    if (vItemSearchFull.length > 0) {
      fItemCodeDependency(vItemSearchFull, sBufferObj, setBufferObj, setUnit);
      document.getElementsByName("B_Qty")[0]?.focus();
    } else {
      document.getElementsByName("B_ItmName")[0]?.focus();
    }
    setItemToggleDropdown(false);
  };

  //GCItemSearch
  const fGCToggleItemOnCellKeyDown = async (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fGCToggleItemOnRowClick(newSelectionModel);
    }
  };

  //Modal View
  const [sViewModal, setViewModal] = useState(false);
  const fView = () => {
    setViewModal(true);
  };

  const fCloseViewModal = (e) => {
    setViewModal(false);
  };

  //Modal Summary
  const [sSummaryModal, setSummaryModal] = useState(false);
  const fSummary = () => {
    setSummaryModal(true);
  };

  const fCloseSummaryModal = (e) => {
    setSummaryModal(false);
  };

  //Modal search

  //MODAL SEARCH

  const [sGridSearchHeadRowData, setGridSearchHeadRowData] = useState([]);
  const [sSearchModalObj, setSearchModalObj] = useState({
    Status: "ENTER",
    VocNo: "",
    PostDt: "",
    Loc: sLocationArr[0]?.UId ? sLocationArr[0]?.UId : "",
    RefNo: "",
  });

  const [sSearchModal, setSearchModal] = useState(false);
  const fSearch = async () => {
    setSearchModal(true);
    // SALESGROUPSSEARCH_GETROW -search salegroup dropdown
    document.getElementById("IdSearch")?.blur();
    setSearchModalObj((obj) => ({
      ...obj,
      Loc: sLocationArr[0]?.UId,
    }));
    GetSearchValue("", "APICallLocModal", sLocationArr[0]?.UId);
  };

  const fCloseSearchModal = (e) => {
    setSearchModal(false);
    fClearSearchModal();
  };

  const fClearSearchModal = (e) => {
    setSearchModalObj({
      Status: "ENTER",
      VocNo: "",
      PostDt: "",
      Loc: sLocationArr[0].UId,
      RefNo: "",
    });
    setGridSearchHeadRowData([]);
  };

  //GCSearch
  const fTrans_Search_Grid_RowClick = (e) => {
    fDisplay(e?.row?.A_VocTyp, e?.row?.A_VocNo, dispatch, fNewDetail);
    fCloseSearchModal();
  };

  //GCSearch
  const fTrans_Search_Grid_KeyDown = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fTrans_Search_Grid_RowClick(newSelectionModel);
    }
  };

  const fonChangeStatusModal = (event, selectArr) => {
    var vSelectedValue = selectArr?.find((value, index) => {
      return value == event.target.value;
    });
    setSearchModalObj((obj) => ({
      ...obj,
      Status: vSelectedValue,
    }));

    GetSearchValue("", "APICALLSTATUS", vSelectedValue);
  };

  const fonChangeVocNoModal = (event) => {
    setSearchModalObj((obj) => ({
      ...obj,
      VocNo: event.target.value,
    }));
  };

  const fonChangeRefNoModal = (event) => {
    setSearchModalObj((obj) => ({
      ...obj,
      RefNo: event.target.value,
    }));
  };

  const fOnChangeDateModel = (event) => {
    if (
      event?.$d == "Invalid Date" ||
      event?.$d == null ||
      event?.$d === undefined ||
      event?.$d === ""
    ) {
      setSearchModalObj((obj) => ({
        ...obj,
        PostDt: "",
      }));
    } else {
      setSearchModalObj((obj) => ({
        ...obj,
        PostDt: event?.$d,
      }));
    }

    let changedDate = event?.$d;
    // setSearchModalObj((obj) => ({
    //   ...obj,
    //   PostDt: !!event.target.value
    //     ? moment(event.target.value, "YYYY-MM-DD")._d
    //     : "",
    // }));
    if (new Date(event?.$d) >= new Date("01-01-1990")) {
      GetSearchValue("", "APICALLDATE", changedDate);
    }
  };

  const fonChangeLocModal = (event, selectArr) => {
    var vSelectedValue = selectArr?.find((obj, index) => {
      return obj.UId == event.target.value;
    });
    setSearchModalObj((obj) => ({
      ...obj,
      Loc: vSelectedValue.UId,
    }));
    GetSearchValue("", "APICallLocModal", vSelectedValue.UId);
  };

  const GetSearchValue = async (e, xAPICALL, xSTATUS) => {
    if (
      e.key === "Enter" ||
      xAPICALL === "APICALLSTATUS" ||
      xAPICALL === "APICALLDATE" ||
      xAPICALL === "APICallLocModal"
    ) {
      let iPostdt =
        xAPICALL === "APICALLDATE"
          ? moment(xSTATUS).format("MM/DD/YYYY")
          : moment(sSearchModalObj.PostDt).format("MM/DD/YYYY");
      if (
        iPostdt == "Invalid date" ||
        iPostdt == null ||
        iPostdt === undefined ||
        iPostdt === ""
      ) {
        iPostdt = "01/01/1900";
      }

      let vSearchObj = {
        Status: xAPICALL === "APICALLSTATUS" ? xSTATUS : sSearchModalObj.Status,
        VocNo: sSearchModalObj.VocNo,
        VocDt: iPostdt,
        // VocDt: "01/01/1900",
        // RefVocNo: sSearchModalObj.RefNo,
        Loc: xAPICALL === "APICallLocModal" ? xSTATUS : sSearchModalObj.Loc,
        UserCd: vRdxuserInfo.UserID,
      };
      let FinalObj = fcheck_null_undefine_replace_empty(vSearchObj);
      const vSearch = await fExecuteAPI(
        "LoadingReceipt_Search_GETROW",
        FinalObj
      );
      if (vSearch.Type?.toUpperCase() === "SUCCESS") {
        let vSearchArr = vSearch?.ResultSet.map((obj, i) => ({
          ...obj,
          id: i + 1,
          // A_VocDt: moment(obj.A_VocDt).format("DD/MM/YYYY"),
        }));
        setGridSearchHeadRowData(vSearchArr);
      } else {
        fAlertToast("FAILED", vSearch?.response?.data?.Status);
      }
    }
  };

  //MODAL SEARCH END

  //MAIN BUTTON

  const fMove_First = (e) => {
    fClearErrorMsg();
    setBufferObj(vBufferObjInit);
    fDisplay(
      sUser_Doc_Arr[0].VocTyp,
      sUser_Doc_Arr[0].VocNo,
      dispatch,
      fNewDetail
    );
    setNavDocValue(1);
  };

  const fMove_Last = (e) => {
    fClearErrorMsg();
    setBufferObj(vBufferObjInit);
    fDisplay(
      sUser_Doc_Arr[sUser_Doc_Arr.length - 1].VocTyp,
      sUser_Doc_Arr[sUser_Doc_Arr.length - 1].VocNo,
      dispatch,
      fNewDetail
    );
    setNavDocValue(sUser_Doc_Arr.length);
  };

  const fMove_Previouse = (e) => {
    fClearErrorMsg();
    setBufferObj(vBufferObjInit);
    if (sNavDocValue > 1) {
      var row = sNavDocValue - 1;
      fDisplay(
        sUser_Doc_Arr[row - 1].VocTyp,
        sUser_Doc_Arr[row - 1].VocNo,
        dispatch,
        fNewDetail
      );
      setNavDocValue(row);
    }
  };

  const fMove_Next = (e) => {
    fClearErrorMsg();
    setBufferObj(vBufferObjInit);

    if (sNavDocValue < sUser_Doc_Arr.length) {
      var row = sNavDocValue + 1;
      fDisplay(
        sUser_Doc_Arr[row - 1].VocTyp,
        sUser_Doc_Arr[row - 1].VocNo,
        dispatch,
        fNewDetail
      );
      setNavDocValue(row);
    }
  };
  const [sWebReportModal, setWebReportModal] = useState(false);
  const [sWebReportUrlModal, setWebReportUrlModal] = useState("");
  const fWebReport = () => {
    setWebReportModal(true);
  };

  const fCloseWebReportModal = (e) => {
    setWebReportModal(false);
  };
  const fPrint = useCallback(
    (xPrnTyp) => {
      

      //http://192.168.50.243:8010/WebReports/WMS/LoadingReceipt?prntyp=WMLDLSTH_DET&voctyp=LD001&vocno=LD00083438	- Detail
      //http://192.168.50.243:8010/WebReports/WMS/LoadingReceipt?prntyp=WMLDLSTH_VAR&voctyp=LD001&vocno=LD00083438	- varience
      let PrintURl =
        vRdxDBKernObj.WEB_REPORT_BASE_URL?.Val +
        "WMS/LoadingReceipt?prntyp=" +
        xPrnTyp +
        "&voctyp=" +
        vRdxWmsHead.A_VocTyp +
        "&vocno=" +
        vRdxWmsHead.A_VocNo;
      setWebReportUrlModal(PrintURl);
      fWebReport();
    },
    [vRdxWmsHead.A_VocNo, vRdxWmsHead.A_VocTyp, vRdxDBKernObj]
  );

  let timeout = null;
  const fSave = async (e) => {
    clearTimeout(timeout);
    fClearErrorMsg();
    timeout = setTimeout(async () => {
      if (vRdxWmsHead.A_DocStat != "ENTER") {
        fAlertToast(
          "FAILED",
          "Not allowed in " + vRdxWmsHead.A_DocStat.toLowerCase() + " mode"
        );
        return;
      }

      let validation = fValidationHead_Client(vRdxWmsHead, setErrorMsg);
      if (!validation && vMediaQuery) {
        fSummary();
      }
      if (!validation) return;

      let validationDetil = fValidationDetail_Client(
        sBufferObj,
        setErrorMsgDetail
      );
      if (!validation && vMediaQuery) {
        fSummary();
      }
      if (!validationDetil) return;

      fSaveHead(
        true,
        setUser_Doc_Arr,
        sUser_Doc_Arr,
        dispatch,
        fNewDetail,
        sBufferObj
      );
    }, 800);
  };

  const fApprove = async (e) => {
    fClearErrorMsg();
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      if (sBufferObj.B_Itmcd != "") {
        fAlertToast("FAILED", "Please save current line item before approve");
        return;
      }

      if (sDetailGridData.length == 0) {
        fAlertToast("INFO", "Add atleast one line item");
        return;
      }
      let validation = fValidationHead_Client(vRdxWmsHead, setErrorMsg);
      if (!validation && vMediaQuery) {
        fSummary();
      }
      if (!validation) return;

      fApproveLoadingReceipt(dispatch, fNewDetail);
    }, 800);
  };

  const fClearErrorMsg = () => {
    setErrorMsg(ErrorMsg);
    setErrorMsgDetail(ErrorMsgDetail);
  };

  const fNew = async () => {
    fClearErrorMsg();
    if (sBufferObj.B_ItmName == "") {
      fNewHead();
      fNewDetail(0, sDocLoading[0]?.VocTyp);
      document.getElementsByName("A_ReceiptDt")[0]?.focus();
    } else {
      fNewDetail(vRdxWmsHead.A_VocNo, vRdxWmsHead.A_VocTyp);
    }
  };

  const fNewHead = async () => {
    dispatch(Set_WmsLoadingReceipt_HeadObject_Init()); // Head Clearing
    // Setting Initial List Box 0th Object
    dispatch(
      Wms_LoadingReceipt_HeadObject_New_Set({
        A_VocTyp: sDocLoading[0]?.VocTyp,
        A_VocTypName: sDocLoading[0]?.VocName,
        A_VocNo: 0,
        A_Loc: vRdxDBLocation[0]?.UID,
      })
    );

    setNavDocValue(1); // nav init 1
    setDetailGridData([]);
    setBufferObj(vBufferObjInit);
  };

  const fNewDetail = (xVocNo, xVocTyp) => {
    setBufferObj(vBufferObjInit);

    setUnit([]);

    fLoad_Grid(xVocNo, 0, setDetailGridData, xVocTyp);

    document.getElementsByName("B_ItmName")[0]?.focus();
  };

  const fDelete = (Srno = sBufferObj.B_Srno) => {
    if (vRdxWmsHead.A_DocStat == "POST") {
      fAlertToast("FAILED", "You are not allowed to delete in post status");
      return;
    }
    confirmAlert({
      title: "Delete",
      message: "Are you want to delete line item.",
      buttons: [
        {
          className: "alertBtn",
          label: "Yes",
          onClick: () => {
            fDeleteDetail(Srno);
          },
        },
        {
          className: "alertBtn",
          label: "No",
          onClick: () => "",
        },
      ],
    });
  };

  // DELETESIHEAD_GETROW

  //DELETESIDETAIL_GETROW
  const fDeleteDetail = async (Srno = sBufferObj.B_Srno) => {
    let vDeleteSIDetailObj = {
      VocTyp: vRdxWmsHead.A_VocTyp,
      VocNo: vRdxWmsHead.A_VocNo,
      SrNo: Srno,
    };

    let FinalObj = fcheck_null_undefine_replace_empty(vDeleteSIDetailObj);
    const vDeleteSIDetail = await fExecuteAPI(
      "LoadingReceipt_DeleteDetails_GETROW",
      FinalObj
    );

    if (vDeleteSIDetail?.Type?.toUpperCase() === "SUCCESS") {
      fAlertToast("SUCCESS", "Successfully Deleted Line Item");
      fNewDetail(vRdxWmsHead.A_VocNo, vRdxWmsHead.A_VocTyp);
    }
  };

  const fDetail_Grid_onRowClick = async (item) => {
    setBufferObj((obj) => ({
      ...obj,
      B_Srno: item.row.H_SrNo,
      B_Itmcd: item.row.H_ItmCd,
      // B_Barcode: "",
      B_ItmName: item.row.ItmName,
      B_Qty: item.row.H_Qty,
      B_Unit: item.row.H_Unit,
      B_UnitName: item.row.UnitName,
      B_BaseQty: item.row.H_BaseQty,

      // B_Ad_CessAmt: 0,
      // B_Ad_PCQty: 0,
    }));
    let currentUnitArr = await GetUnitArr(item.row.H_ItmCd, setUnit);
    let vUnitvalue = currentUnitArr.find((obj) => {
      return obj.Unit === item.row.H_Unit;
    });
    setBufferObj((obj) => ({
      ...obj,
      B_Unit: vUnitvalue?.Unit,
      B_UnitName: vUnitvalue?.Name1,
      B_PackQty: vUnitvalue?.PackQty,
      Packing: vUnitvalue?.PackDesc,
    }));

    fCloseViewModal();
  };

  //accountDetail start
  const [sAccountDetailModal, setAccountDetailModal] = useState(false);
  const [sGridDataAccountDetailRows, setGridDataAccountDetailRows] = useState(
    []
  );
  const [sGridDataAccountDetailColumns, setGridDataAccountDetailColumns] =
    useState([
      {
        field: "id",
        headerName: "Sr.No",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "AcCd",
        headerName: "AcCd",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "AcName",
        headerName: "AcName",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "Br",
        headerName: "Br",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "BrName",
        headerName: "BrName",
        width: 130,
        headerClassName: "grid-header-row",
      },

      {
        field: "AmtLc",
        headerName: "AmtLc",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "DrCr",
        headerName: "DrCr",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "Narr",
        headerName: "Narr",
        width: 200,
        headerClassName: "grid-header-row",
      },
      {
        field: "Narr1",
        headerName: "Narr1",
        width: 200,
        headerClassName: "grid-header-row",
      },
    ]);
  const fOpenAccountDetailModal = () => {
    setAccountDetailModal(true);
  };
  const fAccountDetail = async (e) => {
    const { HeadObject } = LoadingReceipt();
    await GetAccountPostingDetail(
      HeadObject.A_VocTyp,
      HeadObject.A_VocNo,
      setGridDataAccountDetailRows
    );

    fOpenAccountDetailModal();
  };
  const fCloseAccountDetailModal = (e) => {
    setAccountDetailModal(false);
  };
  //accountDetail end

  //fLinkDocument start
  const [sLinkDocumentModal, setLinkDocumentModal] = useState(false);
  const [sGridDataLinkDocumentRows, setGridDataLinkDocumentRows] = useState([]);
  const [sGridDataLinkDocumentColumns, setGridDataLinkDocumentColumns] =
    useState([
      {
        field: "A_VocTyp",
        headerName: "Doc.Type",
        hide: false,
        width: 80,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "VocName",
        headerName: "Doc.Name",
        hide: false,
        width: 180,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "A_VocNo",
        headerName: "Doc.No",
        hide: false,
        width: 80,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "A_DocStat",
        headerName: "Status",
        hide: false,
        width: 50,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "id",
        headerName: "id",
        hide: false,
        width: 40,
        align: "left",
        headerAlign: "left",
      },
    ]);
  const fOpenLinkDocumentModal = () => {
    setLinkDocumentModal(true);
  };
  const fLinkDocument = async (e) => {
    const { HeadObject } = LoadingReceipt();
    await GetLinkDocument(
      HeadObject.A_VocTyp,
      HeadObject.A_VocNo,
      sTrnTyp,
      setGridDataLinkDocumentRows
    );

    fOpenLinkDocumentModal();
  };
  const fCloseLinkDocumentModal = (e) => {
    setLinkDocumentModal(false);
  };
  //LinkDocument end

  //esc keyZ close item dropdown
  const escFunction = useCallback((event) => {
    if (event.key === "Escape") {
      setItemToggleDropdown(false);
    }
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const onload = useCallback(async () => {
  

    let iAttributeResp = await GetAttributes(
      setUser_Doc_Arr,
      setObjectRights,
      setDocLoading,
      setLocationArr
    );

    let icurrentDocLoading = {
      VocTyp: "",
      VocName: "",
      Paymode: "",
    };

    let vDocLoadingArr = iAttributeResp.DocLoading;

    if (vDocLoadingArr.length > 0) {
      // setDocLoading(vDocLoadingArr);
      icurrentDocLoading = vDocLoadingArr[0];
    }
    let vLocationArr = iAttributeResp.Loaction;
    let icurrentLocation = {
      UId: "",
      Name1: "",
    };
    if (vLocationArr.length > 0) {
      // setLocationArr(vLocationArr);
      icurrentLocation = vLocationArr[0];
    }

    dispatch(
      Set_WmsLoadingReceipt_HeadObject_Set({
        ...vRdxWmsHead,
        A_VocTyp:
          vRdxWmsHead?.A_VocTyp == "" ||
          vRdxWmsHead?.A_VocTyp == null ||
          vRdxWmsHead?.A_VocTyp == undefined
            ? icurrentDocLoading.VocTyp
            : vRdxWmsHead.A_VocTyp,
        A_VocTypName:
          vRdxWmsHead?.A_VocTyp == "" ||
          vRdxWmsHead?.A_VocTyp == null ||
          vRdxWmsHead?.A_VocTyp == undefined
            ? icurrentDocLoading.VocName
            : vRdxWmsHead.A_VocTypName,
        A_Loc:
          vRdxWmsHead.A_Loc == "" ||
          vRdxWmsHead?.A_Loc == null ||
          vRdxWmsHead?.A_Loc == undefined
            ? icurrentLocation.UId
            : vRdxWmsHead.A_Loc,
      })
    );

    fLoad_Grid(
      vRdxWmsHead.A_VocNo, //0
      0, //srno
      setDetailGridData,
      vRdxWmsHead?.A_VocTyp == "" ||
        vRdxWmsHead?.A_VocTyp == null ||
        vRdxWmsHead?.A_VocTyp == undefined
        ? icurrentDocLoading.VocTyp
        : vRdxWmsHead.A_VocTyp
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, vRdxDBLocation]);

  useEffect(() => {
    var resultObj = fCheck_Doc_Rights_001(
      vRdxWmsHead.A_DocStat,
      vRdxWmsHead.A_VocTyp,
      !!sObjectRights && sObjectRights.length > 0 ? sObjectRights : []
    );
    setObjRights(resultObj);
  }, [vRdxWmsHead.A_DocStat, vRdxWmsHead.A_VocTyp, sObjectRights]);

  useEffect(() => {
    if (
      vRdxWmsHead.A_DocStat !== "ENTER" ||
      vRdxWmsHead.A_Loc === null ||
      vRdxWmsHead.A_Loc === undefined ||
      vRdxWmsHead.A_Loc === "" ||
      sBufferObj.B_Itmcd === "" ||
      sBufferObj.B_Unit === ""
    ) {
      setTransItemStockObj({
        RPStock: 0,
        MSP: 0,
        CostPr: 0,
        LPRate: 0,
      });
      return;
    } else {
      getTransItemStockUOM(
        setTransItemStockObj,
        sBufferObj.B_Itmcd,
        sBufferObj.B_Unit,
        vRdxWmsHead.A_Loc
      );
    }
  }, [
    dispatch,
    sBufferObj.B_Itmcd,
    sBufferObj.B_Unit,
    vRdxWmsHead.A_Loc,
    vRdxWmsHead.A_DocStat,
  ]);

  // CLICK ANY WHERE AND CLOSE IF TOGGLE IS CLOSED
  useEffect(() => {
    const handleClick = (event) => {
      if (sItemToggleDropdown) {
        const toggleElement = event.target.closest(".toggleSearch");
        if (!toggleElement) {
          setItemToggleDropdown(false);
        }
      }
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [sItemToggleDropdown]);

  useEffect(() => {
    document.addEventListener("keydown", escFunction, false);

    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, [escFunction]);

  const fkeyup = useCallback((e) => {
    if (e.key === "Enter") {
      let lastChild = document?.getElementById("WmsLoadingReceiptContent");

      let TagArr = !!lastChild
        ? lastChild?.querySelectorAll(".lastkeyDetect")
        : "";
      let ilengthz = !!TagArr ? TagArr?.length : "";

      if (!!ilengthz) {
        if (
          TagArr[ilengthz - 1]?.getElementsByTagName("input")[0]?.name ==
            e.target.name &&
          document?.getElementById("WMSDocStatID")?.innerHTML == "ENTER"
        ) {
          confirmAlert({
            title: "Save",
            message: "Are you want to Save.",
            buttons: [
              {
                className: "alertBtn",
                name: "SaveYes",
                label: "Yes",
                onClick: () => {
                  document.getElementById("IdSave")?.click();
                },
              },
              {
                className: "alertBtn",
                label: "No",
                onClick: () => "",
              },
            ],
          });
        }
      }
    }
  }, []);

  useEffect(() => {
    onload();
  }, [onload]);

  useEffect(() => {
    document.addEventListener("keyup", (e) => fkeyup(e), false);
    return () => {
      document.removeEventListener("keyup", fkeyup, false);
    };
  }, [fkeyup]);

  const fkeyup2 = useCallback(
    (e) => {
      let vRdxPrint = "WMLDLSTH_DET";
      FShortCutKey(
        e,
        "IdNew",
        "IdSave",
        "IdApprove",
        "IdSearch",
        "IdDelete",
        "IdAudit",
        vRdxPrint,
        fPrint
      );
    },
    [fPrint]
  );

  useLayoutEffect(() => {
    window.addEventListener("keyup", fkeyup2);

    return () => {
      window.removeEventListener("keyup", fkeyup2);
    };
  }, [fkeyup2]);

  const [GridDataColumnsWmsSiDetail, setGridDataColumnsWmsSiDetail] = useState(
    GridDataColumnsWmsSiDetail_Def
  );
  const [GridDataColumnsItemSearch, setGridDataColumnsItemSearch] = useState(
    GridDataColumnsItemSearch_Def
  );
  const [GridDataColumnsSearch, setGridDataColumnsSearch] = useState(
    GridDataColumnsSearch_Def
  );

  useEffect(() => {
    GetGitterColumns(
      setGridDataColumnsWmsSiDetail,
      "LOADINGRECEIPT_DETAIL",
      GridDataColumnsWmsSiDetail
    );
    GetGitterColumns(
      setGridDataColumnsItemSearch,
      "LOADINGRECEIPT_ITEM_SEARCH",
      GridDataColumnsItemSearch
    );
    GetGitterColumns(
      setGridDataColumnsSearch,
      "LOADINGRECEIPT_SEARCH",
      GridDataColumnsSearch
    );
    GetGitterColumns(
      setGridDataAccountDetailColumns,
      "ACPSTINGDTLTRNS",
      sGridDataAccountDetailColumns
    );
    GetGitterColumns(
      setGridDataLinkDocumentColumns,
      "WMINV08LINKDDOC",
      sGridDataLinkDocumentColumns
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="container-fluid">
      {/* mobile Screen nav  */}
      <GCNAV
        fNew={fNew}
        xDisableNew={sObjRights.RNew == "N"}
        fSave={fSave}
        xDisableSave={sObjRights.RSave == "N"}
        sRightClick={sRigntClick}
        xRightClick={(e) => {
          fLeftClick(e);
          setShowMore(false);
          setRigntClick(false);
          setTimeout(() => {
            document.getElementsByName("A_ReceiptDt")[0]?.focus();
          }, 100);
        }}
        xLeftClick={(e) => {
          fRightClick(e);
          setShowMore(false);
          setRigntClick(true);
          setTimeout(() => {
            document.getElementsByName("B_ItmName")[0]?.focus();
          }, 100);
        }}
        setShowMore={setShowMore}
        sShowMore={sShowMore}
        fDelete={fDelete}
        xDisableDelete={
          vRdxWmsHead.A_DocStat == "ENTER" && sBufferObj.B_Srno > 0
            ? false
            : sObjRights.RDelete == "N"
            ? true
            : false
        }
        isBtnDraft={false}
        fDraft={() => {
          fApprove("DRAFT");
        }}
        xDisableDraft={sObjRights.RApprove == "N"}
        fApprove={() => {
          fApprove("POST");
        }}
        xDisableApprove={sObjRights.RApprove == "N"}
        fView={() => {
          fView();
        }}
        fSummary={() => {
          fSummary();
        }}
        fSearch={() => {
          fSearch();
        }}
      />
      <div style={{ paddingTop: vMediaQuery ? "50px" : "" }}>
        <div className="row" style={{ padding: "0px" }}>
          <div className="col-12" style={{ padding: "0px" }}>
            <div className="Wms-outbound-grv">
              <Grid
                container
                spacing={0}
                className="my-2 Wms-inbound-grn-nav-sm-hide"
                columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                sx={{ alignItems: "center" }}
              >
                <Grid item xs={1} sm={2} md={1} lg={1}>
                  <CmpButton
                    xbtnName="New"
                    xOnClick={(e) => fNew(0)}
                    xVariant="text"
                    xDisabled={sObjRights.RNew == "N"}
                    xSize="small"
                    xId={"IdNew"}
                    xSendIcon={<AddBoxRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  <CmpButton
                    xbtnName="Save"
                    xOnClick={fSave}
                    xVariant="text"
                    xDisabled={sObjRights.RSave == "N"}
                    xSize="small"
                    xId={"IdSave"}
                    xSendIcon={<SaveRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  <CmpButton
                    xbtnName="Approve"
                    xOnClick={fApprove}
                    xVariant="text"
                    xDisabled={sObjRights.RApprove == "N"}
                    xSize="small"
                    xId={"IdApprove"}
                    xSendIcon={<CheckCircleOutlineRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  <CmpButton
                    xbtnName="Search"
                    xOnClick={fSearch}
                    xVariant="text"
                    xDisabled={false}
                    xSize="small"
                    xId={"IdSearch"}
                    xSendIcon={<SearchRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  <CmpButton
                    xbtnName="Delete"
                    xOnClick={() => {
                      fDelete();
                    }}
                    xVariant="text"
                    xDisabled={
                      vRdxWmsHead.A_DocStat == "ENTER" && sBufferObj.B_Srno > 0
                        ? false
                        : sObjRights.RDelete == "N"
                        ? true
                        : false
                    }
                    xSize="small"
                    xId="IdDelete"
                    xSendIcon={<DeleteRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2} md={0.5} lg={0.5}>
                  <CmpButtonKIcon
                    xOnClick={fMove_First}
                    xDisabled={false}
                    xIcon={<FirstPageIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid
                  item
                  xs={1}
                  sm={2}
                  md={0.5}
                  lg={0.5}
                  className="text-center"
                >
                  <CmpButtonKIcon
                    xOnClick={fMove_Previouse}
                    xDisabled={false}
                    xIcon={<ArrowBackIosIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid item xs={1} sm={4} md={1} lg={1} className="text-center">
                  {sNavDocValue} of {sUser_Doc_Arr.length}
                </Grid>
                <Grid
                  item
                  xs={1}
                  sm={2}
                  md={0.5}
                  lg={0.5}
                  className="text-center"
                >
                  <CmpButtonKIcon
                    xOnClick={fMove_Next}
                    xDisabled={false}
                    xIcon={<ArrowForwardIosIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid
                  item
                  xs={1}
                  sm={2}
                  md={0.5}
                  lg={0.5}
                  className="text-center"
                >
                  <CmpButtonKIcon
                    xOnClick={fMove_Last}
                    xDisabled={false}
                    xIcon={<LastPageIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid item xs={1} sm={2} md={1} lg={1}>
                  <DropdownButton
                    id="dropdown-basic-button"
                    title="Print"
                    variant="outlined"
                    size="sm"
                    disabled={sObjRights.RPrint == "N" ? true : false}
                  >
                    <Dropdown.Item
                      onClick={(e) => {
                        fPrint("WMLDLSTH_DET");
                      }}
                    >
                      Details
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={(e) => {
                        fPrint("WMLDLSTH_VAR");
                      }}
                    >
                      Variance
                    </Dropdown.Item>
                  </DropdownButton>
                </Grid>
                {/* <Grid item xs={1} sm={1} md={1.5} lg={1.5}>
                <CmpButton
                  xbtnName="Account Detail"
                  xOnClick={fAccountDetail}
                  xVariant="text"
                  xDisabled={false}
                  xSize="small"
                  xSendIcon={<AccountBalanceOutlinedIcon />}
                />
              </Grid> */}
                <Grid item xs={1} sm={1} md={1.5} lg={1.5}>
                  <GCMenuBtn
                    menuLabel="More"
                    menuItems={[
                      { label: "Account Detail", onClick: fAccountDetail },
                      // { label: "Link Document", onClick: fLinkDocument },
                    ]}
                  />
                </Grid>
              </Grid>

              <>
                <div id="wms-salese-invoice-id">
                  <div className=" wms-incoice-sales-m main-wms-sales-invoice-hide-sm main-wms-sales-invoice-show-sm ">
                    <GCHead
                      xDisableBasedOnGridDataLength={sDetailGridData.length > 0}
                      xErrorMsg={sErrorMsg}
                      vRdxuserLoc={sLocationArr}
                      xKey={fKeyLoadingReceipt}
                      vRdxWmsHead={vRdxWmsHead}
                      fonSelectedGrnType={fGrnType}
                      sDocLoadingGrnType={sDocLoading}
                      fGrnDate={fGrnDate}
                      fReceiptDate={fReceiptDate}
                      fLocation={fLocation}
                      fTruck={fTruck}
                      fDriver={fDriver}
                    />
                  </div>
                  <div className="wms-sales-Content wms-incoice-sales-m main-wms-sales-invoice-hide-sm ">
                    <div className="wms-incoice-sales-m">
                      <GCContent
                        sTransItemStockObj={sTransItemStockObj}
                        xTransItemStockShow={
                          vRdxuserInfo?.UserRights?.ViewCost?.toUpperCase() ==
                          "Y"
                        }
                        vRdxWmsHead={vRdxWmsHead}
                        xContent_Focus={fContent_Focus}
                        xContent_Blur={fContent_Blur}
                        xErrorMsgDetail={sErrorMsgDetail}
                        xKey={fKeyLoadingReceiptContent}
                        xBufferObj={sBufferObj}
                        sUnit={sUnit}
                        fUnit={fUnit}
                        fOpenContentItemSearchModalKey={fItemSearchKey}
                        fQty={fQty}
                        fQtyEnter={fQtyEnter}
                        fPacking={fPacking}
                        //GC toggle
                        fItemName={fItemName} //onchange main input
                        xMediaQuery={vMediaQuery} //mobile screen
                        xonClickbtn={fItemSearchKey} // onclick icon open div on main screen
                        xrows={sGridSelectRowData} //Grid Row GCToggle Search from API
                        xcolumns={GridDataColumnsItemSearch} //GCToggleSearch-Grid col GCToggle Search fron Action
                        xRowCellClick={fGCToggleItemOnCellKeyDown} //GCToggleSearch-grid clic
                        xRowClick={fGCToggleItemOnRowClick} //GCToggleSearch- grid click
                        xToggle={sItemToggleDropdown} //GCToggleSearch-to show div using true/false (after xonClickbtn state value will be passed)
                        xData={ItemSearchData} // GCToggleSearch-select-tag arr
                        xOnChangeDropdownInput={fOnChangeItem} //GCToggleSearch-input search onchane DATA/TYPE
                        xDropdownObj={sItemSearchDropdownObj} // GCToggleSearch-object DATA/TYPE
                        xOnKeyUpDropdownInput={fOnKeyUpItem} //GCToggleSearch-
                      />
                      {vMediaQuery && (
                        <DetailTblCard
                          data={sDetailGridData}
                          onClick={fDetail_Grid_onRowClick}
                          fDelete={fDelete}
                          xDisableDelete={
                            vRdxWmsHead.A_DocStat == "ENTER"
                              ? false
                              : sObjRights.RDelete == "N"
                              ? true
                              : false
                          }
                        />
                      )}
                    </div>
                    <div className="wms-sales-content-grid xs-screen-hide">
                      <div style={{ height: "60vh", width: "100%" }}>
                        <DataGrid
                          rowHeight={30}
                          headerHeight={40}
                          getRowClassName={(params) =>
                            params.indexRelativeToCurrentPage % 2 === 0
                              ? "mui-even-row"
                              : "mui-odd-row"
                          }
                          sx={{
                            border: 1,
                            borderColor: "primary.light",
                              '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: '#0d73bb',
                    color: 'white'
                  },
                          }}
                          rows={sDetailGridData}
                          columns={GridDataColumnsWmsSiDetail}
                          onRowClick={fDetail_Grid_onRowClick}
                          hideFooter={sDetailGridData.length < 100}
                          // components={{
                          //   Toolbar: GridToolbar,
                          // }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="wms-sales-footer wms-incoice-sales-m main-wms-sales-invoice-hide-sm ">
                    <WmsFooter vRdxWmsHead={vRdxWmsHead} />
                  </div>
                  {/* <div>
                  <Grid
                    container
                    spacing={0}
                    columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                    className="align-items-start"
                  >
                    <Grid item xs={12} sm={12} md={8} lg={12} className="">
                      <CmpStatus xStatus={vRdxWmsHead.A_DocStat} />
                    </Grid>
                  </Grid>
                </div> */}
                </div>
              </>
            </div>
          </div>
        </div>
      </div>

      {/* //View Modal  */}
      <Modal
        open={sViewModal}
        onClose={fCloseViewModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"View"} onClose={fCloseViewModal} />
          <div className="py-2">
            <div style={{ height: "70vh", width: "100%" }}>
              <DataGrid
                rowHeight={30}
                headerHeight={40}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0
                    ? "mui-even-row"
                    : "mui-odd-row"
                }
                sx={{
                  border: 1,
                  borderColor: "primary.light",
                }}
                rows={sDetailGridData}
                columns={GridDataColumnsWmsSiDetail}
                onRowClick={fDetail_Grid_onRowClick}
                hideFooter={sDetailGridData.length < 100}
                // components={{
                //   Toolbar: GridToolbar,
                // }}
              />
            </div>
          </div>
        </Box>
      </Modal>
      {/* summary  */}
      <Modal
        open={sSummaryModal}
        onClose={fCloseSummaryModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"Summary"} onClose={fCloseSummaryModal} />
          <div className="py-2">
            <WmsFooter vRdxWmsHead={vRdxWmsHead} />
          </div>
        </Box>
      </Modal>

      {/* Search  */}
      <GCLoadingListSearch
        open={sSearchModal}
        xStatusArr={sStatusArr}
        xLocationArr={sLocationArr}
        fonChangeStatusModal={fonChangeStatusModal}
        fonChangeVocNoModal={fonChangeVocNoModal}
        fOnChangeDateModel={fOnChangeDateModel}
        fonChangeLocModal={fonChangeLocModal}
        fonChangeRefNoModal={fonChangeRefNoModal}
        xGetSearchValue={GetSearchValue}
        fCloseSearchModal={fCloseSearchModal}
        fClearSearchModal={fClearSearchModal}
        GridSearchHeadRowData={sGridSearchHeadRowData}
        GridDataColumnsSearch={GridDataColumnsSearch}
        xOnCellKeyDownSearch={fTrans_Search_Grid_KeyDown}
        xOnRowClickSearch={fTrans_Search_Grid_RowClick}
        vMediaQuery={vMediaQuery}
        xEnterObj={sEnterKeyObj}
        xTitle={"Loading Receipt - Search"}
        xStatusVal={sSearchModalObj.Status}
        xVocNoVal={sSearchModalObj.VocNo}
        xPostDtVal={sSearchModalObj.PostDt}
        xLocVal={sSearchModalObj.Loc}
        xRefNoVal={sSearchModalObj.RefNo}
      />
      <GCWebReport
        xfCloseWebReportModal={fCloseWebReportModal}
        xWebReportUrlModal={sWebReportUrlModal}
        xTitle="Report"
        xWebReportModal={sWebReportModal}
      />
      <GCAccountDetail
        xOpen={sAccountDetailModal}
        fCloseDetailModal={fCloseAccountDetailModal}
        GridDataAccountDetailColumns={sGridDataAccountDetailColumns}
        GridDataAccountDetailRows={sGridDataAccountDetailRows}
        xTitle={"Account Detail"}
        xLabelVocType={vRdxWmsHead.A_VocTyp}
        xLabelVocName={vRdxWmsHead.A_VocTypName}
        xLabelVocNo={vRdxWmsHead.A_VocNo}
      />

      <GCLinkDocument
        xOpen={sLinkDocumentModal}
        fCloseDetailModal={fCloseLinkDocumentModal}
        GridDataLinkDocumentColumns={sGridDataLinkDocumentColumns}
        GridDataLinkDocumentRows={sGridDataLinkDocumentRows}
        xTitle={"Link Document"}
        xLabelVocType={vRdxWmsHead.A_VocTyp}
        xLabelVocName={vRdxWmsHead.A_VocTypName}
        xLabelVocNo={vRdxWmsHead.A_VocNo}
      />
    </div>
  );
}
